import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { utility } from '../../utility';
import { FileManagementSearchCondition } from './FileManagementSearchCondition';
import { FileManagementSearchResult } from './FileManagementSearchResult';

/**
 * FileManagement Page Component
 */
const FileManagement = () => {
  const inputCondition = {
    FileName: "",
    UploadBy: "",
    UploadDateFrom: null,
    UploadDateTo: null,
    Model: "",
    ProductType: "",
    BusinessArea: "",
  };
  const screenId = 'MyM601';
  const apiRequest = useMyMApi(screenId);
  const { screenSettings } = useWebContext(screenId);
  const [resultPageInfo, setResultPageInfo] = useState({});
  const [searchCondition, setSearchCondition] = useState({});
  const [searchInputCondition, setSearchInputCondition] = useState(inputCondition);
  const [searchedInputCondition, setSearchedInputCondition] = useState(inputCondition);
  const [sortModel, setSortModel] = useState([]);
  const [isSearchConditionLoading, setIsSearchConditionLoading] = useState(true);
  const [isFileListLoading, setIsFileListLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    const callbackmanagementLoadContext = (result) => {
      setSearchCondition(result.Condition)
      setResultPageInfo(result.Result)
      setIsSearchConditionLoading(false);
      setIsFileListLoading(false);
    }
    apiRequest.requestJson(`api/box-file/management-load?LimitMaxRowCount=${screenSettings.MaxRowCount}`, 'GET', callbackmanagementLoadContext)
  }, []);

  useEffect(() => {
    if (isSearchConditionLoading) return;
    requestSearch();
  }, [pageNumber, sortModel]);

  /**
   * 検索処理
   */
  const requestSearch = () => {
    setIsFileListLoading(true);
    const callbackBoxFileListSuccessContext = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (pageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(pageNumber - 1);
        return;
      }
      setResultPageInfo(result);
      setIsFileListLoading(false);
    }
    const callbackBoxFileListFaildContext = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsFileListLoading(false);
    }
    let condition
    if (isSearch) {
      // 検索の場合、現在のフォームの状態で検索をし検索条件を退避
      condition = searchInputCondition;
      setSearchedInputCondition({ ...searchInputCondition })
    } else {
      // ソート・ページングの場合、過去の検索条件を元に検索する
      condition = searchedInputCondition ;
    }
    let queryParameters = { ...condition };
    if (sortModel[0]) {
      queryParameters.SortItems = `${sortModel[0].field} ${sortModel[0].sort}`;
    }

    queryParameters.UploadDateTo = utility.formatDateTime(utility.getLastTimeDate(queryParameters.UploadDateTo));
    queryParameters.PageNumber = pageNumber;
    queryParameters.LimitMaxRowCount = screenSettings.MaxRowCount;

    apiRequest.requestJson(`api/box-file/search-boxfile-list?${utility.makeEncodeParameter(queryParameters)}`, 'GET', callbackBoxFileListSuccessContext, callbackBoxFileListFaildContext);
    setIsSearch(false);
  };
  
  if (isSearchConditionLoading)
    return <MyMProgress />

  return (
    <Box>
      <FileManagementSearchCondition
        screenId={screenId}
        searchCondition={searchCondition}
        searchInputCondition={searchInputCondition}
        setSearchInputCondition={setSearchInputCondition}
        setSortModel={setSortModel}
        setPageNumber={setPageNumber}
        setIsSearch={setIsSearch }
      />
      <FileManagementSearchResult
        screenId={screenId}
        resultPageInfo={resultPageInfo}
        sortModel={sortModel}
        setSortModel={setSortModel}
        isFileListLoading={isFileListLoading}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
    </Box>
  );
}
export default FileManagement;